export default {
	methods: {
		getDateParam() {
			// Format of date String.
			const DATE_FORMAT = "sv-SE"; // YYYY-MM-DD
			// Properties of the date object. E.g:
			// Sets the fields of the date(year, month, day, hour, minutes, ...)
			// Sets the timezone of the date. If none mentioned, no offset will be applied to the user agent's date.
			const DATE_OPTIONS = {
				year: "numeric",
				month: "2-digit",
				day: "2-digit",
			};
			// Get the date in the user agent's timezone
			const localeTime = new Date();
			if (process.client) {
				// return the user agent's locale time in the YYYY-MM-DD format
				return localeTime.toLocaleDateString(DATE_FORMAT, DATE_OPTIONS);
			} else {
				// return the user agent's locale time in the YYYY-MM-DD format with the EST timezone offset
				return localeTime.toLocaleDateString(DATE_FORMAT, {
					...DATE_OPTIONS,
					timeZone: "UTC",
				});
			}
		},
	},
};
